export default __webpack_public_path__ + "static/logo_privacyshield@2x-71c002585598bd9df769d255d2efee6d.png";